(function(angular){
    'use strict';

    angular.module('nucleus.bm-help-widget', ['nucleus.HideHelpJumpToLinkDirective'])
        .component('bmHelpWidget', {
            templateUrl: 'dashboard/bm-help-widget/bm-help-widget.2js.html',
            controller: bmHelpWidgetCtrl,
            controllerAs: 'vm'
        })
        .component('bmCommonArticles', {
            templateUrl: 'dashboard/bm-help-widget/bm-common-articles.html',
            controller: bmCommonArticlesCtrl,
            controllerAs: 'vm'
        });

    bmHelpWidgetCtrl.$inject = ['HelpService','$uibModal'];
    function bmHelpWidgetCtrl(HelpService, $uibModal) {
        /*jshint validthis:true */
        var vm = this;
        vm.$onInit = onInit;
        vm.videosLoaded = false;

        function onInit() {
            HelpService.loadVideos().then(function(resp) {
                vm.videosLoaded = true;
                vm.helpVideos = resp;
            });
        }

        vm.openHelpVideoModal = function openHelpVideoModal(video) {
            $uibModal.open({
                templateUrl: 'dashboard/bm-help-widget/help-video-modal.2js.html',
                controller: 'HelpVideoModalCtrl as vm',
                backdrop: 'static',
                windowClass: 'help-widget-modal',
                resolve: {
                    video: function(){
                        return video;
                    }
                }
            });
        };
    }

    bmCommonArticlesCtrl.$inject = ['HelpService'];
    function bmCommonArticlesCtrl(HelpService) {
        /*jshint validthis:true */
        let vm = this;
        vm.topicsLoaded = false;

        vm.$onInit = function() {
            HelpService.loadTopics().then(function(resp) {
                vm.topicsLoaded = true;
                vm.helpTopics = resp;
            });
        };
    }
})(window.angular);
